/**
 * @Author: alexandre
 * @Date:   2018-03-08T14:08:42-05:00
 * @Email:  alexandre@atomicmotion.com
 * @Filename: details.js
 * @Last modified by:   alexandre
 * @Last modified time: 2018-09-10T10:04:40-04:00
 * @Copyright: Atomic Motion
 */

/**
 * @Author: alexandre
 * @Date:   2018-03-07T11:33:46-05:00
 * @Email:  alexandre@atomicmotion.com
 * @Filename: App.js
 * @Last modified by:   alexandre
 * @Last modified time: 2018-09-10T10:04:40-04:00
 * @Copyright: Atomic Motion
 */

import React, {
  Component,
} from 'react';
import ReactTable from 'react-table'
import Popup from './popup'

class Details extends Component {

  constructor(props) {
    super(props);

    this.state = {
      ncpldata: null,
      carriers: [],
      popup: false,
      carrierId: null,
    };
  }

  componentWillMount = () => {

      this.setState({
        ncpldata: this.props.ncpldata,
        carrierId: this.props.match.params.carrierId
      })
  }



  closePopup = (e) => {

    e.preventDefault();
    this.setState({
      popup: false,
    })
  }

  openPopup = (e) => {

    e.preventDefault();
    let state = this.state.popup;

    this.setState({
      popup: !state,
    })
  }

  goBack = (e) => {

    e.preventDefault();
    // scroll.scrollTo(
    //   document.getElementById("root").offsetTop - 20,
    //   {
    //     duration: 400,
    //     smooth: true,
    //   });

    this.props.history.push("/")
  }

  print = (e) => {

    e.preventDefault();
    window.print();
  }



  copyAddress = (name, address) => {
    console.log(address);
    let address_str = name;
    address_str += address.attention.length !== 0 ? "\nATTN: " + address.attention : "";
    address_str += address.street1.length !== 0 ? "\n" + address.street1 : "";
    address_str += address.street2.length !== 0 ? ", " + address.street2 : "";
    address_str += address.city.length !== 0 ? "\n" + address.city : "";
    address_str += address.province.length !== 0 ? ", " + address.province : "";
    address_str += address.postal_code.length !== 0 ? ", " + address.postal_code : "";


    const el = document.createElement('textarea');
    el.value = address_str;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    alert(this.props.lang === "en" ? "Address has been copied!" : "L'adresse a été copiée!")
  }



  flattenCarriers = (ncpldata) => {
    console.log(ncpldata);

    let returnData = [];

    for (let i = 0; i < ncpldata.length; i++) {
      if (ncpldata[i].bin === this.state.carrierId) {

        returnData[0] = this.props.lang === "en" ? {
          name: ncpldata[i].name.en,
          id: ncpldata[i].bin,
          versionOne: ncpldata[i].versions[0],
          versionTwo: ncpldata[i].versions[1],
          age_days: ncpldata[i].age_days,

          networkZero: ncpldata[i].network[0].name.en,
          networkZeroPhone: ncpldata[i].network[0].telephone[0].phone,

          networkOne: ncpldata[i].network.length >= 2 ? ncpldata[i].network[1].name.en : null,
          networkOnePhone: ncpldata[i].network.length >= 2 ? ncpldata[i].network[1].telephone[0].phone : null,

          networkTwo: ncpldata[i].network.length === 3 ? ncpldata[i].network[2].name.en : null,
          networkTwoPhone: ncpldata[i].network.length === 3 ? ncpldata[i].network[2].telephone[0].phone : null,

          batch: ncpldata[i].batch === "Y" ? (this.props.lang === "en" ? "Batch" : "Par lots") : (this.props.lang === "en" ? "Real Time" : "En temps réel"),
          policy: ncpldata[i].policy_number.en,
          division_number: ncpldata[i].division_number.en,
          certificate_number: ncpldata[i].certificate_number.en,

          claim_01: ncpldata[i].claim_01 === "N" ? null : "Y",
          claim_11: ncpldata[i].claim_11 === "N" ? null : "Y",
          claim_21: ncpldata[i].claim_21 === "N" ? null : "Y",

          reversal_02: ncpldata[i].reversal_02 === "N" ? null : "Y",
          reversal_12: ncpldata[i].reversal_12 === "N" ? null : "Y",

          predetermination_03: ncpldata[i].predetermination_03 === "N" ? null : "Y",
          predetermination_13: ncpldata[i].predetermination_13 === "N" ? null : "Y",
          predetermination_23: ncpldata[i].predetermination_23 === "N" ? null : "Y",
          predetermination_multi: ncpldata[i].predetermination_multi === "N" ? null : "Y",

          outstanding_04: ncpldata[i].outstanding_04 === "N" ? null : "Y",
          outstanding_14: ncpldata[i].outstanding_14 === "N" ? null : "Y",


          summary_reconciliation_05: ncpldata[i].summary_reconciliation_05 === "N" ? null : "Y",
          summary_reconciliation_15: ncpldata[i].summary_reconciliation_15 === "N" ? null : "Y",

          payment_reconciliation_06: ncpldata[i].payment_reconciliation_06 === "N" ? null : "Y",
          payment_reconciliation_16: ncpldata[i].payment_reconciliation_16 === "N" ? null : "Y",


          cob_07: ncpldata[i].cob_07 === "N" ? null : "Y",

          eligibility_08: ncpldata[i].eligibility_08 === "N" ? null : "Y",
          eligibility_18: ncpldata[i].eligibility_18 === "N" ? null : "Y",

          attachment_09: ncpldata[i].attachment_09 === "N" ? null : "Y",
          attachment_19: ncpldata[i].attachment_19 === "N" ? null : "Y",

          cob_instructions_en: ncpldata[i].cob_instructions.en,

          address: {},
        } : {
            name: ncpldata[i].name.fr,
            id: ncpldata[i].bin,
            versionOne: ncpldata[i].versions[0],
            versionTwo: ncpldata[i].versions[1],
            age_days: ncpldata[i].age_days,

            networkZero: ncpldata[i].network[0].name.fr,
            networkZeroPhone: ncpldata[i].network[0].telephone[0].phone,

            networkOne: ncpldata[i].network.length >= 2 ? ncpldata[i].network[1].name.fr : null,
            networkOnePhone: ncpldata[i].network.length >= 2 ? ncpldata[i].network[1].telephone[0].phone : null,

            networkTwo: ncpldata[i].network.length === 3 ? ncpldata[i].network[2].name.fr : null,
            networkTwoPhone: ncpldata[i].network.length === 3 ? ncpldata[i].network[2].telephone[0].phone : null,

            batch: ncpldata[i].batch === "Y" ? (this.props.lang === "en" ? "Batch" : "Par lots") : (this.props.lang === "en" ? "Real Time" : "En temps réel"),
            policy: ncpldata[i].policy_number.fr,
            division_number: ncpldata[i].division_number.fr,
            certificate_number: ncpldata[i].certificate_number.fr,

            claim_01: ncpldata[i].claim_01 === "N" ? null : "Y",
            claim_11: ncpldata[i].claim_11 === "N" ? null : "Y",
            claim_21: ncpldata[i].claim_21 === "N" ? null : "Y",

            reversal_02: ncpldata[i].reversal_02 === "N" ? null : "Y",
            reversal_12: ncpldata[i].reversal_12 === "N" ? null : "Y",

            predetermination_03: ncpldata[i].predetermination_03 === "N" ? null : "Y",
            predetermination_13: ncpldata[i].predetermination_13 === "N" ? null : "Y",
            predetermination_23: ncpldata[i].predetermination_23 === "N" ? null : "Y",
            predetermination_multi: ncpldata[i].predetermination_multi === "N" ? null : "Y",

            outstanding_04: ncpldata[i].outstanding_04 === "N" ? null : "Y",
            outstanding_14: ncpldata[i].outstanding_14 === "N" ? null : "Y",


            summary_reconciliation_05: ncpldata[i].summary_reconciliation_05 === "N" ? null : "Y",
            summary_reconciliation_15: ncpldata[i].summary_reconciliation_15 === "N" ? null : "Y",

            payment_reconciliation_06: ncpldata[i].payment_reconciliation_06 === "N" ? null : "Y",
            payment_reconciliation_16: ncpldata[i].payment_reconciliation_16 === "N" ? null : "Y",


            cob_07: ncpldata[i].cob_07 === "N" ? null : "Y",

            eligibility_08: ncpldata[i].eligibility_08 === "N" ? null : "Y",
            eligibility_18: ncpldata[i].eligibility_18 === "N" ? null : "Y",

            attachment_09: ncpldata[i].attachment_09 === "N" ? null : "Y",
            attachment_19: ncpldata[i].attachment_19 === "N" ? null : "Y",

            cob_instructions_en: ncpldata[i].cob_instructions.fr,

            address: {},
        }

        var a = null;
        var b = null;
        var position = null;
        
        if (returnData[0].cob_instructions_en.indexOf("Blue-on-blue") !== -1){
          a = returnData[0].cob_instructions_en;
          b = "<br/>";
          position = returnData[0].cob_instructions_en.indexOf("Blue-on-blue");

          returnData[0].cob_instructions_en = [a.slice(0, position), b, a.slice(position)].join('');
        }

        if (returnData[0].cob_instructions_en.indexOf("« bleu contre bleu » :") !== -1){
          a = returnData[0].cob_instructions_en;
          b = "<br/>";
          position = returnData[0].cob_instructions_en.indexOf("« bleu contre bleu » :");

          returnData[0].cob_instructions_en = [a.slice(0, position), b, a.slice(position)].join('');
        }

        if (returnData[0].cob_instructions_en.indexOf("Bleu contre bleu") !== -1){
          a = returnData[0].cob_instructions_en;
          b = "<br/>";
          position = returnData[0].cob_instructions_en.indexOf("Bleu contre bleu");

          returnData[0].cob_instructions_en = [a.slice(0, position), b, a.slice(position)].join('');
        }

        for (let ii = 0; ii < ncpldata[i].address.length; ii++) {
          returnData[0].address[ii] = ncpldata[i].address[ii];
        }

        returnData[0].claimsProcessorPhone = ncpldata[i].telephone[0].value;

        try {
          if (this.props.lang === "en") {
            returnData[0].claimsProcessor = ncpldata[i].name.en !== ncpldata[i].claims_processor.name.en ? ncpldata[i].claims_processor.name.en : null;
          }
          else{
            returnData[0].claimsProcessor = ncpldata[i].name.fr !== ncpldata[i].claims_processor.name.fr ? ncpldata[i].claims_processor.name.fr : null;
          }
        } catch (err) {
          console.log(err)
        }

      }
    }

    //this.scrollToElement();
    return returnData
  }

  render() {
    if (this.props.ncpldata.length === 0){
      return("loading...")
    }
    else{
      document.getElementById('banner').classList.add('no-print');

      let info = null;
      let name = null;
      let columns = null;
      let columnsTransaction = null;
      let cob_instructions_en = null;
      let columnAddress = null;
      let address = [];

      if (this.props.ncpldata) {

        try {
          info = this.flattenCarriers(this.props.ncpldata)
          name = info[0].name;
        } catch (err) {
          console.log(err)
        }

        try {
          cob_instructions_en = info[0].cob_instructions_en;
        } catch (err) {
          console.log(err)
        }

        columns = [{
            id: 'name',
            accessor: 'name',
            Header: this.props.lang === "en" ? 'Carrier Name' : "Nom de l’assureur",
            sortable: false,
            resizable: false,
          },
          {
            accessor: 'id',
            Header: this.props.lang === "en" ? 'CDAnet Carrier ID' : "Numéro d'identification (ID)",
            sortable: false,
            resizable: false,
            headerClassName: 'grey',
          },
          {
            id: 'version',
            accessor: data => <span>{data.versionOne}{data.versionTwo ? ", " + data.versionTwo : ""}</span>,
            Header: this.props.lang === "en" ? 'CDAnet Version' : 'Version',
            sortable: false,
            resizable: false,
          },
          {
            accessor: 'age_days',
            Header: this.props.lang === "en" ? 'Age Limit (Days)' : 'Délai alloué pour la soumission (jours)',
            sortable: false,
            resizable: false,
            headerClassName: 'grey',
          },
          {
            id: "networkZero",
            accessor: data => <span>{data.networkZero ? data.networkZero : ""}</span>,
            Header: <span>{this.props.lang === "en" ? 'Network 1' : 'Réseau 1'}</span>,
            sortable: false,
            resizable: false,
          },
          {
            id: "networkZeroPhone",
            accessor: data => <span>{data.networkZeroPhone ? data.networkZeroPhone : ""}</span>,
            Header: this.props.lang === "en" ? 'Network 1 Help Desk' : "Centre d’assistance du réseau 1",
            sortable: false,
            resizable: false,
            headerClassName: 'grey',
          },
          {
            id: "networkOne",
            accessor: data => <span>{data.networkOne ? data.networkOne : "no"}</span>,
            Header: this.props.lang === "en" ? 'Network 2' : 'Réseau 2',
            sortable: false,
            resizable: false,
            show: info[0].networkOne != null ? true : false,
          },
          {
            id: "networkOnePhone",
            accessor: data => <span>{data.networkOnePhone ? data.networkOnePhone : "no"}</span>,
            Header: this.props.lang === "en" ? 'Network 2 Help Desk' : 'Centre d’assistance du réseau 2',
            sortable: false,
            resizable: false,
            show: info[0].networkOne != null ? true : false,
            headerClassName: 'grey',
          },
          {
            id: "networkTwo",
            accessor: data => <span>{data.networkTwo ? data.networkTwo : "no"}</span>,
            Header: this.props.lang === "en" ? 'Network 3' : 'Réseau 3',
            sortable: false,
            resizable: false,
            show: info[0].networkTwo != null ? true : false
          },
          {
            id: "networkTwoPhone",
            accessor: data => <span>{data.networkTwoPhone ? data.networkTwoPhone : "no"}</span>,
            Header: this.props.lang === "en" ? 'Network 3 Help Desk' : 'Centre d’assistance du réseau 3',
            sortable: false,
            resizable: false,
            show: info[0].networkTwo != null ? true : false,
            headerClassName: 'grey',
          },
          {
            id: "claims",
            accessor: data => <span>{data.claimsProcessor ? data.claimsProcessor : "no"}</span>,
            Header: this.props.lang === "en" ? 'Claims Processor' : 'Tiers payeur',
            sortable: false,
            resizable: false,
            show: info[0].claimsProcessor != null ? true : false
          },
          {
            id: "claimsPhone",
            accessor: data => <span>{data.claimsProcessorPhone ? data.claimsProcessorPhone : "no"}</span>,
            Header: this.props.lang === "en" ? 'Claims Processor Help Desk' : 'Centre d\'assistance du tiers payeur',
            sortable: false,
            resizable: false,
            show: info[0].claimsProcessor != null ? true : false,
            headerClassName: 'grey',
          },
          {
            id: "batch",
            accessor: "batch",
            Header: this.props.lang === "en" ? 'Processing Mode' : 'Mode de traitement',
            sortable: false,
            resizable: false,
          },
          {
            id: 'policy',
            accessor: data => data.policy.length !== 0 ? <span>{data.policy}</span> : <span>&#8291;</span>,
            Header: this.props.lang === "en" ? 'Policy Number' : 'Numéro de police',
            sortable: false,
            resizable: false,
            headerClassName: 'grey',
          },
          {
            id: 'division_number',
            accessor: data => data.division_number.length !== 0 ? <span>{data.division_number}</span> : <span>&#8291;</span>,
            Header: this.props.lang === "en" ? 'Division Number' : 'Numéro de division',
            sortable: false,
            resizable: false
          },
          {
            id: 'certificate_number',
            accessor: data => data.certificate_number.length !== 0 ? <span>{data.certificate_number}</span> : <span>&#8291;</span>,
            Header: this.props.lang === "en" ? 'Certificate Number' : 'Numéro du titulaire',
            sortable: false,
            resizable: false,
            headerClassName: 'grey',
          },
        ];

        columnsTransaction = [{
            id: 'claim_01',
            accessor: data => data.claim_01 === "Y"? <span style={{color: "green", }}>&#10003;</span> : <span style={{color: "red", }}>&#10007;</span>,
          Header: <span className="">{this.props.lang === "en" ? 'Claim (01)' : 'Demande de prestations (01)' }</span>,
            sortable: false,
            resizable: false,
            headerClassName: 'grey',
          },
          {
            id: 'cob_07',
            accessor: data => data.cob_07 === "Y"? <span style={{color: "green", }}>&#10003;</span> : <span style={{color: "red", }}>&#10007;</span>,
            Header: <span className="">{this.props.lang === "en" ? 'COB Claim (07)' : 'Coordination des prestations (CP) d’une demande (07)'}</span>,
            sortable: false,
            resizable: false,
            headerClassName: 'grey',
          },
          {
            id: 'claim_11',
            accessor: data => data.claim_11 === "Y"? <span style={{color: "green", }}>&#10003;</span> : <span style={{color: "red", }}>&#10007;</span>,
            Header: <span className="sub-row">{this.props.lang === "en" ? 'Claim Acknowledgement (11)' : 'AR d’une demande de prestations (11)'}</span>,
            sortable: false,
            resizable: true,
            headerClassName: 'grey',
          },
          {
            id: 'claim_21',
            accessor: data => data.claim_21 === "Y"? <span className="last-row" style={{color: "green", }}>&#10003;</span> : <span className="last-row" style={{color: "red", }}>&#10007;</span>,
            Header: <span className="sub-row last-row">{this.props.lang === "en" ? 'Claim EOB (21)' : 'DP d’une demande de prestations (21)'}</span>,
            sortable: false,
            resizable: false,
            headerClassName: 'grey',
          },
          {
            id: 'reversal_02',
            accessor: data => data.reversal_02 === "Y"? <span style={{color: "green", }}>&#10003;</span> : <span style={{color: "red", }}>&#10007;</span>,
            Header: <span className="">{this.props.lang === "en" ? 'Claim Reversal (02)' : 'Annulation d’une demande de prestations (02)'}</span>,
            sortable: false,
            resizable: false,
            className: 'white',
          },
          {
            id: 'reversal_12',
            accessor: data => data.reversal_02 === "Y"? <span className="last-row" style={{color: "green", }}>&#10003;</span> : <span className="last-row" style={{color: "red", }}>&#10007;</span>,
            Header: <span className="sub-row last-row">{this.props.lang === "en" ? 'Claim Reversal Response (12)' : 'Réponse à l’annulation d’une demande (12)'}</span>,
            sortable: false,
            resizable: false,
            className: 'white',
          },
          {
            id: 'predetermination_03',
            accessor: data => data.predetermination_03 === "Y"? <span style={{color: "green", }}>&#10003;</span> : <span style={{color: "red", }}>&#10007;</span>,
            Header: <span className="">{this.props.lang === "en" ? 'Predetermination (03)' : 'Plan de traitement (03)'}</span>,
            sortable: false,
            resizable: false,
            headerClassName: 'grey',
          },
          {
            id: 'predetermination_13',
            accessor: data => data.predetermination_13 === "Y"? <span style={{color: "green", }}>&#10003;</span> : <span style={{color: "red", }}>&#10007;</span>,
            Header: <span className="sub-row">{this.props.lang === "en" ? 'Predetermination Acknowledgement (13)' : 'AR d’un plan de traitement (13)'}</span>,
            sortable: false,
            resizable: false,
            headerClassName: 'grey',
          },
          {
            id: 'predetermination_23',
            accessor: data => data.predetermination_23 === "Y"? <span style={{color: "green", }}>&#10003;</span> : <span style={{color: "red", }}>&#10007;</span>,
            Header: <span className="sub-row">{this.props.lang === "en" ? 'Predetermination EOB (23)' : 'DP d’un plan de traitement (23)'}</span>,
            sortable: false,
            resizable: false,
            headerClassName: 'grey',
          },
          {
            id: 'predetermination_multi',
            accessor: data => data.predetermination_multi === "Y"? <span className="last-row" style={{color: "green", }}>&#10003;</span> : <span className="last-row" style={{color: "red", }}>&#10007;</span>,
            Header: <span className="sub-row last-row">{this.props.lang === "en" ? 'Predetermination Multi-Page' : 'Plan de traitement à pages multiples'}</span>,
            sortable: false,
            resizable: false,
            headerClassName: 'grey',
          },
          {
            id: 'outstanding_04',
            accessor: data => data.outstanding_04 === "Y"? <span style={{color: "green", }}>&#10003;</span> : <span style={{color: "red", }}>&#10007;</span>,
            Header: <span className="">{this.props.lang === "en" ? 'Request for Outstanding Transaction (04)' : 'Demande relative aux transactions en suspens (04)'}</span>,
            sortable: false,
            resizable: false,
            className: 'white',
          },
          {
            id: 'outstanding_14',
            accessor: data => data.outstanding_14 === "Y"? <span className="last-row" style={{color: "green", }}>&#10003;</span> : <span className="last-row" style={{color: "red", }}>&#10007;</span>,
            Header: <span className="sub-row last-row">{this.props.lang === "en" ? 'Outstanding Transaction Response (14)' : 'AR d’une demande relative aux transactions en suspens (14)'}</span>,
            sortable: false,
            resizable: false,
            className: 'white',
          },
          {
            id: 'summary_reconciliation_05',
            accessor: data => data.summary_reconciliation_05 === "Y"? <span style={{color: "green", }}>&#10003;</span> : <span style={{color: "red", }}>&#10007;</span>,
            Header: <span className="">{this.props.lang === "en" ? 'Summary Reconciliation (05)' : 'Rapprochement sommaire (05)'}</span>,
            sortable: false,
            resizable: false,
            headerClassName: 'grey',
          },
          {
            id: 'summary_reconciliation_15',
            accessor: data => data.summary_reconciliation_15 === "Y"? <span className="last-row" style={{color: "green", }}>&#10003;</span> : <span className="last-row" style={{color: "red", }}>&#10007;</span>,
            Header: <span className="sub-row last-row">{this.props.lang === "en" ? 'Summary Response (15)' : 'Réponse à une demande de rapprochement sommaire (15)'}</span>,
            sortable: false,
            resizable: false,
            headerClassName: 'grey',
          },
          {
            id: 'payment_reconciliation_06',
            accessor: data => data.payment_reconciliation_06 === "Y"? <span style={{color: "green", }}>&#10003;</span> : <span style={{color: "red", }}>&#10007;</span>,
            Header: <span className="">{this.props.lang === "en" ? 'Payment Reconciliation (06)' : 'Demande de rapprochement des paiements (06)'}</span>,
            sortable: false,
            resizable: false,
            className: 'white',
          },
          {
            id: 'payment_reconciliation_16',
            accessor: data => data.payment_reconciliation_16 === "Y"? <span className="last-row" style={{color: "green", }}>&#10003;</span> : <span className="last-row" style={{color: "red", }}>&#10007;</span>,
            Header: <span className="sub-row last-row">{this.props.lang === "en" ? 'Payment Response (16)' : 'Réponse à une demande de rapprochement des paiements (16)'}</span>,
            sortable: false,
            resizable: false,
            className: 'white',
          },
          {
            id: 'eligibility_08',
            accessor: data => data.eligibility_08 === "Y"? <span style={{color: "green", }}>&#10003;</span> : <span style={{color: "red", }}>&#10007;</span>,
            Header: <span className="">{this.props.lang === "en" ? 'Eligibility (08)' : 'Vérification d’admissibilité (08)'}</span>,
            sortable: false,
            resizable: false,
            headerClassName: 'grey',
          },
          {
            id: 'eligibility_18',
            accessor: data => data.eligibility_18 === "Y"? <span className="last-row" style={{color: "green", }}>&#10003;</span> : <span className="last-row" style={{color: "red", }}>&#10007;</span>,
            Header: <span className="sub-row last-row">{this.props.lang === "en" ? 'Eligibility Response (18)' : 'Réponse à une vérification d’admissibilité (18)'}</span>,
            sortable: false,
            resizable: false,
            headerClassName: 'grey',
          },
          {
            id: 'attachment_09',
            accessor: data => data.attachment_09 === "Y"? <span style={{color: "green", }}>&#10003;</span> : <span style={{color: "red", }}>&#10007;</span>,
            Header: <span className="">{this.props.lang === "en" ? 'Attachment (09)' : 'Pièce jointe (09)'}</span>,
            sortable: false,
            resizable: false,
            className: 'white',
          },
          {
            id: 'attachment_19',
            accessor: data => data.attachment_19 === "Y"? <span style={{color: "green", }}>&#10003;</span> : <span style={{color: "red", }}>&#10007;</span>,
            Header: <span className="sub-row">{this.props.lang === "en" ? 'Attachment Response (19)' : 'Réponse à une pièce jointe (19)'}</span>,
            sortable: false,
            resizable: false,
            className: 'white',
          },
        ];

        for (let i = 0; i < Object.keys(info[0].address).length; i++) {

          columnAddress = [
            {
              id: 'notes_en',
              accessor: data => data.address[i].notes[this.props.lang].length !== 0 ? <span>{data.address[i].notes[this.props.lang]}</span> : <span>&#8291;</span>,
              Header: this.props.lang === "en" ? 'Notes' : 'Remarque',
              sortable: false,
              resizable: false,
            },
            {
              id: 'name',
              accessor: 'name',
              Header: this.props.lang === "en" ? 'Carrier Name' : "Nom de l’assureur",
              sortable: false,
              resizable: false,
              headerClassName: 'grey',
            },
            {
              id: 'attention',
              accessor: data => data.address[i].attention.length !== 0 ? <span>{data.address[i].attention}</span> : <span>&#8291;</span>,
              Header: 'Attention',
              sortable: false,
              resizable: false,
            },
            {
              id: 'street1',
              accessor: data => data.address[i].street1.length !== 0 ? <span>{data.address[i].street1}</span> : <span>&#8291;</span>,
              Header: this.props.lang === "en" ? 'Street 1' : 'Rue 1',
              sortable: false,
              resizable: false,
              headerClassName: 'grey',
            },
            {
              id: 'street2',
              accessor: data => data.address[i].street2.length !== 0 ? <span>{data.address[i].street2}</span> : <span>&#8291;</span>,
              Header: this.props.lang === "en" ? 'Street 2' : 'Rue 2',
              sortable: false,
              resizable: false,
            },
            {
              id: 'city',
              accessor: data => data.address[i].city.length !== 0 ? <span>{data.address[i].city}</span> : <span>&#8291;</span>,
              Header: this.props.lang === "en" ? 'City' : 'Ville',
              sortable: false,
              resizable: false,
              headerClassName: 'grey',
            },
            {
              id: 'province',
              accessor: data => data.address[i].province.length !== 0 ? <span>{data.address[i].province}</span> : <span>&#8291;</span>,
              Header: 'Province',
              sortable: false,
              resizable: false,
            },
            {
              id: 'postal_code',
              accessor: data => data.address[i].postal_code.length !== 0 ? <span>{data.address[i].postal_code}</span> : <span>&#8291;</span>,
              Header: this.props.lang === "en" ? 'Postal Code' : 'Code postal',
              sortable: false,
              resizable: false,
              headerClassName: 'grey',
            },            
          ];

          address[i] = <div key={i} className="address-container"><h3>{this.props.lang === "en" ? "Address" : "Addresse"} {i+1} </h3>
            <a href="javascript:void(0);" class="no-print" onClick={ () => this.copyAddress(info[0].name, info[0].address[i])}>{this.props.lang === "en" ? "Copy Address" : "Copier l'adresse"}</a>
            <ReactTable
            data={info}
            columns={columnAddress}
            showPaginationBottom={false}
            defaultPageSize={1000}
            minRows={0}

            getTdProps={(state, rowInfo, column, instance) => {
              return {
                onClick: (e, handleOriginal) => {

                  //this.props.unMountCarrier()
                }
              }
            }}
          /></div>

        }
        
      } else {

        info = [];
        columns = [{}];
        columnsTransaction = [{}];
      }

   

      return (
        <div id="divToPrint" ref="details" className="details fadeIn">
          <a className="no-print" style={{float:"right"}} href="#" onClick={ this.print }>{this.props.lang === "en" ? 'Print details' : 'Imprimer les détails'}</a>
          <h2>{name}</h2>

          <div className="table-container info" id="table1">
            <div className="header-container first-header-container">
              <a className="no-print" href="goback" onClick={ this.goBack }>{this.props.lang === "en" ? 'Back to carrier list' : 'Retour à la liste des assureurs'}</a>
            </div>
            <ReactTable
                data={info}
                columns={columns}
                showPaginationBottom={false}
                defaultPageSize={1000}
                minRows={0}


                getTdProps={(state, rowInfo, column, instance) => {
                return {
                  onClick: (e, handleOriginal) => {
                  }
                }
              }}
              />
            </div>

            <div className="table-container print-page-break" id="table2">
              <div className="header-container">
              <h2>{this.props.lang === "en" ? (<span>Supported Transactions</span>) : (<span>Transactions acceptées</span>)}</h2>
                <a className="no-print" href="goback" onClick={ this.goBack }>{this.props.lang === "en" ? 'Back to carrier list' : 'Retour à la liste des assureurs'}</a>
              </div>
              <ReactTable
                  data={info}
                  columns={columnsTransaction}
                  showPaginationBottom={false}
                  defaultPageSize={1000}
                  minRows={0}
                  className='rt-support-transactions'

                  getTdProps={(state, rowInfo, column, instance) => {
                  return {
                    onClick: (e, handleOriginal) => {
                    }
                  }
                }}
                />
              </div>

            <div className="table-container info no-print" id="table3">
              <div className="header-container">
              <h2>{this.props.lang === "en" ? 'Coordination of Benefit Information' : 'Information pour la coordination des prestations'}</h2>
              <a className="no-print" href="goback" onClick={this.goBack}>{this.props.lang === "en" ? 'Back to carrier list' : 'Retour à la liste des assureurs'}</a>
              </div>
            <p dangerouslySetInnerHTML={{ __html: cob_instructions_en }}></p>
            </div>

            <div className="table-container info print-page-break">
              <div className="header-container">
              <h2>{this.props.lang === "en" ? 'Mailing Address for Claim Forms' : 'Adresse postale pour les formulaires de demande d’indemnisation'}</h2>
              {<a href="popup" class="no-print" onClick={this.openPopup}>{this.props.lang === "en" ? 'Contribute carrier mailing address information' : 'Fournir l’adresse postale de l’assureur'}</a>}
              </div>
                {
                  address.length > 0 ? address : <span>{this.props.lang === "en" ? "Currently Unknown" : "Actuellement inconnu"}</span>
                }
            </div>

            {(() => {
              if( this.state.popup ){
                return ( <Popup lang={this.props.lang} name={name} display={this.state.popup} openPopup={this.openPopup}/> )
              }
              else{
                return(null)
              }
            })()}
          </div>
      );
    }
  }
}

export default Details;